import { defineMessages } from "react-intl";

export const messages = defineMessages({
  companyLogoAlt: {
    id: "rovo-extension.navigation.company-logo.alt",
    defaultMessage: "Company logo",
    description: "Alt text for company logo image",
  },
  homeLabel: {
    id: "rovo-extension.navigation.home.label",
    defaultMessage: "Home",
    description: "Label for home navigation",
  },
  siteNavigationLabel: {
    id: "rovo-extension.navigation.site.label",
    defaultMessage: "site",
    description:
      "Label for site navigation component. Label is used for screenreaders only, not rendered in UI. Here, site refers to the Atlassian organization the user is on.",
  },
  siteIconLabel: {
    id: "rovo-extension.navigation.site-icon.label",
    defaultMessage: "site",
    description:
      "Label for site icon in site switcher. Label is used for screenreaders only, not rendered in UI. Here, site refers to the Atlassian organization the user is on. Icon is the ADS office building icon.",
  },
  appSwitcherTooltip: {
    id: "rovo-extension.navigation.app-switcher.tooltip",
    defaultMessage: "Switch to...",
    description: "Tooltip text for app switcher",
  },
});
